// Import model
import { DataviewOtgCatalogStyleResponse } from '../models/DataviewOtgCatalogStyleResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterOtgCatalogStyleRequest } from '../models/FilterOtgCatalogStyleRequest';
import { OtgCatalogStyle } from '../models/OtgCatalogStyle';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterOtgCatalogStyleRequestSerializer } from './FilterOtgCatalogStyleRequestSerializer';
import { OtgCatalogStyleSerializer } from './OtgCatalogStyleSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewOtgCatalogStyleResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewOtgCatalogStyleResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewOtgCatalogStyleResponse instance
   */
  static deserialize(json: string): DataviewOtgCatalogStyleResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewOtgCatalogStyleResponse instance
   */
  static fromObject(obj: any): DataviewOtgCatalogStyleResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewOtgCatalogStyleResponse');
    }


    const instance: DataviewOtgCatalogStyleResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        OtgCatalogStyleSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterOtgCatalogStyleRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewOtgCatalogStyleResponse instances
   */
  static deserializeArray(json: string): DataviewOtgCatalogStyleResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewOtgCatalogStyleResponse instance to a JSON string
   */
  static serialize(instance: DataviewOtgCatalogStyleResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewOtgCatalogStyleResponse instance to a plain object
   */
  static toObject(instance: DataviewOtgCatalogStyleResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        OtgCatalogStyleSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterOtgCatalogStyleRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewOtgCatalogStyleResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewOtgCatalogStyleResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
